import React from 'react';
import { Box, Typography } from '@mui/material';

const TEXT_PRIMARY = '#1F2937';
const TEXT_MUTED = '#9CA3AF';

const formatDetailValue = (value) => {
  if (value == null) {
    return '';
  }

  if (Array.isArray(value)) {
    return value.filter(Boolean).join(' · ');
  }

  return String(value);
};

const TimelineDetailRows = ({
  rows = [],
  gap = 0.14,
  labelFontSize = '0.62rem',
  valueFontSize = '0.74rem',
}) => {
  const safeRows = Array.isArray(rows)
    ? rows.filter((row) => row && formatDetailValue(row?.value))
    : [];

  if (!safeRows.length) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap,
        minWidth: 0,
      }}
    >
      {safeRows.map((detail, index) => (
        <Box
          key={`${detail?.label || 'detail'}-${index}`}
          sx={{
            display: 'flex',
            alignItems: 'baseline',
            gap: 0.35,
            flexWrap: 'wrap',
            minWidth: 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              fontSize: labelFontSize,
              lineHeight: 1.16,
              fontWeight: 900,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: TEXT_MUTED,
              mt: 0,
              mb: 0,
            }}
          >
            {detail?.label || 'Detail'}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: valueFontSize,
              lineHeight: 1.18,
              fontWeight: 700,
              color: detail?.valueColor || TEXT_PRIMARY,
              mt: 0,
              mb: 0,
              minWidth: 0,
              wordBreak: 'break-word',
            }}
          >
            {formatDetailValue(detail?.value)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default React.memo(TimelineDetailRows);
